const env = window._env_;

export const getTokenStorageKey = () =>
  `oidc.user:${env.OIDC_AUTHORIY}:${env.OIDC_CLIENT}`;

export const getEnviromentVariable = name => {
  return env[name];
};

export const getToken = () => {
  return sessionStorage.getItem(getTokenStorageKey());
};

export const setToken = token => {
  sessionStorage.setItem(getTokenStorageKey(), JSON.stringify(token));
};

export const clearToken = () => {
  sessionStorage.removeItem(getTokenStorageKey());
};

const SIMULATED_AUTHENTICATION_HOSTS = [
  "localhost",
  "127.0.0.1",
  "::1",
  "[::1]",
  "paguefacildsv.sefaz.net",
];

export const isLocalHost = (hostname = window.location.hostname) =>
  ["localhost", "127.0.0.1", "::1", "[::1]"].includes(
    String(hostname || "").toLowerCase()
  );

export const isSimulatedAuthenticationEnabled = (
  hostname = window.location.hostname
) => {
  return (
    env.SIMULATED_AUTHENTICATION_ENABLED === true &&
    SIMULATED_AUTHENTICATION_HOSTS.includes(
      String(hostname || "").toLowerCase()
    )
  );
};
